import { render, staticRenderFns } from "./TemplateDropdown.vue?vue&type=template&id=406f9fc4&scoped=true"
import script from "./TemplateDropdown.vue?vue&type=script&lang=js"
export * from "./TemplateDropdown.vue?vue&type=script&lang=js"
import style0 from "./TemplateDropdown.vue?vue&type=style&index=0&id=406f9fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f9fc4",
  null
  
)

export default component.exports